module.exports = __webpack_public_path__ + "img/pro-photo16.10400852.jpg";